import axios from 'axios'
import { API_BASE } from '../config'

function authHeaders() {
    let token = localStorage.getItem('token');
    return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
}

// Friends, and the notifications that come with them
export default class Friends {
    // GET /friends/me - The logged-in user's friends and the requests waiting either way:
    // { visibility, max, friends: [{ id, username, since, online, lastSeen }], incoming: [{ id, username, requestedAt }], outgoing }
    getMine() {
        return axios.get(`${API_BASE}/friends/me`, authHeaders()).then(x => x.data);
    }

    // GET /friends/of/:who - A player's friends list, by username or user id:
    // { id, relation, visibility, visible, count, friends } where relation is what they are to the viewer ('self',
    // 'friends', 'outgoing', 'incoming' or 'none') and count and friends are null when the viewer may not see them
    getOf(who) {
        return axios.get(`${API_BASE}/friends/of/${encodeURIComponent(who)}`, authHeaders()).then(x => x.data);
    }

    // POST /friends/:id - Ask a player to be friends, or accept their request: { relation }
    add(userID) {
        return axios.post(`${API_BASE}/friends/${encodeURIComponent(userID)}`, {}, authHeaders()).then(x => x.data);
    }

    // DELETE /friends/:id - Remove a friend, withdraw a request, or decline one: { relation: 'none' }
    remove(userID) {
        return axios.delete(`${API_BASE}/friends/${encodeURIComponent(userID)}`, authHeaders()).then(x => x.data);
    }

    // GET /notifications - The newest notifications:
    // { unread, notifications: [{ id, kind, from: { id, username }, createdAt, read, pending }] }
    getNotifications() {
        return axios.get(`${API_BASE}/notifications`, authHeaders()).then(x => x.data);
    }

    // POST /notifications/read - Mark them all read
    markRead() {
        return axios.post(`${API_BASE}/notifications/read`, {}, authHeaders()).then(x => x.data);
    }
}
